// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selection-group[data-v-47f003ce] {\n  height: 90px;\n}\n.autoscale-label[data-v-47f003ce] label {\n  font-size: 0.75em;\n}\n.width-85[data-v-47f003ce] {\n  width: 85px;\n}\n.width-400[data-v-47f003ce] {\n  width: 400px;\n}\n[data-v-47f003ce] .v-list-item {\n  font-size: 0.875rem !important;\n}", ""]);
// Exports
module.exports = exports;
